<template>
  <div id="app">
    <Navbar />
     
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';
export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  },
};
</script>

<style>
/* Styles globaux */
body {
  display:block;
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}


</style>